import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useInitials } from "@/hooks/use-initials";
import { getStableAvatarColorStyle } from "@/lib/avatar-colors";
import { cn } from "@/lib/utils";

// Airie's branded icon, served from inertia/public. The system user never has an
// uploaded avatar, so we render the logo instead of falling back to an "A" initial.
const AIRIE_LOGO_SRC = "/AIRIE_ICON .webp";

export type CompanyUserAvatarProps = {
  id?: number | string | null;
  companyUserId?: number | string | null;
  userId?: number | string | null;
  name?: string | null;
  email?: string | null;
  avatar?: string | null;
  /** When true, this is the Airie system user — show the Airie logo as the avatar. */
  isSystem?: boolean;
  className?: string;
  fallbackClassName?: string;
};

export function CompanyUserAvatar({
  id,
  companyUserId,
  userId,
  name,
  email,
  avatar,
  isSystem,
  className,
  fallbackClassName,
}: CompanyUserAvatarProps) {
  const getInitials = useInitials();
  const displayName = name?.trim() || email?.trim() || "?";
  const stableKey = companyUserId ?? userId ?? id ?? email ?? displayName;
  const imageSrc = isSystem ? (avatar ?? AIRIE_LOGO_SRC) : (avatar ?? undefined);

  return (
    <Avatar className={cn("rounded-md", className)}>
      <AvatarImage src={imageSrc} alt={displayName} />
      <AvatarFallback
        className={cn("rounded-md font-semibold", fallbackClassName)}
        style={getStableAvatarColorStyle(stableKey)}
      >
        {getInitials(displayName)}
      </AvatarFallback>
    </Avatar>
  );
}
